import React from "react";
import CustomNavbar from "../components/CustomNavbar";
import Breadcrumb from "../components/Breadcrumb";
import FooterTwo from "../components/Footer/FooterTwo";
import FooterData from "../components/Footer/FooterData";
import { NavLink} from 'react-router-dom';


const phsCad = () => {
    let list = [
        "PHS Draw is a new generation software program written using Java / VB / VC++, standalone without any need of third party software vendor support or software license. PHS Draw is a modern software tool used for designing complete pipe hanger assemblies using the standard catalogue products of Pipe Hangers & Supports.",
        "The software is innovatively designed to retain data in a file structure customer wise / project wise / pipe system wise.",
        "The file size is extremely small for a complete project.",
        "Assemblies can be drawn based on standard hanger assembly configurations or user creatable configuration based on a graphical user interface.",
        "After answering a few dialogue boxes on load, travel, pipe size, temperature, insulation thickness, assembly length etc, the drawing is displayed with all details.",
        "Warnings if any for exceeding 4° Angulation due to horizontal movement or extra heavy hydro loads are displayed on screen & printed as a special note on drawings.",
        "Drawings can be exported as PDF files or as. dxf files to be imported into AutoCad for any additional work involving drawings of structural elements if any.",
        "Complete BOM's can be extracted into text or excel & prices can be created.",
    ];
  return (
    <div className="body_wrapper">
      <CustomNavbar
        slogo="sticky_logo"
        mClass="menu_four"
        nClass="w_menu ml-auto mr-auto"
      />
      <Breadcrumb
        breadcrumbClass="breadcrumb_area"
        imgName="breadcrumb/banner_bg.png"
        Ptitle="Pipe Hangers & Supports Software"
        Pdescription=""
      />
      <section className="contact_info_area sec_pad bg_color">
        <div className="container">
          <p>
          We are pioneers in implementing custom built software packages for Hanger Supports used in the piping industry. The software packages allow the user to produce accurate drawings of hanger assemblies based on inputs & a GUI based system. These packages are distributed to users at no cost. Please
          <NavLink title="Contact" to="/Contact"> contact </NavLink> 
          us for access to downloads.

          </p>

          <h6 className="f_p f_size_20 t_color3 f_500 mb_20">PHS Draw</h6>
          <ul className="list-unstyled p_body">
              {list.map((x) => (
                   <li className="mt-3"> <i class="icon_check_alt2"></i>  {x}</li>
              )
              )}
             
          </ul>
        </div>
      </section>
      <FooterTwo FooterData={FooterData} />
    </div>
  );
};

export default phsCad;
